// @ts-nocheck
import React, {useCallback, useReducer} from 'react'

const AuthContext = React.createContext()

function AuthProvider(props) {
 
  return (
    <AuthContext.Provider {...props} />
  )
}

function useAuth() {
  const context = React.useContext(AuthContext)
  if (context === undefined) {
    throw new Error(`useAuth must be used within a AuthProvider`)
  }
  return context
}


const SETUSER = 'SETUSER';
const SETPREF = 'SETPREF';
const SETCONFIG = 'SETCONFIG';

const initialState = {
    user: null,
    config:  null
};

const reducer = (state, action) => {
 
 
  switch (action.type) {
    case SETUSER: 
          var newState = { ...state, user: action.user  };
          window.localStorage.setItem("currentuser", JSON.stringify(action.user));

      return newState;


    case SETPREF:

      var newState2 = {...state, preferences: {...state.preferences, ...action.preferences}};
     
      window.localStorage.setItem("preferences", JSON.stringify(newState2.preferences));
      return newState2;

      case SETCONFIG:
          return { ...state, config: action.config };
          
      
    default: 
        throw new Error("Invalid action" +action.type);
  }

};

const useUserState = initialPresent => {

  const [state, dispatch] = useReducer(reducer, initialState, (initialState)=>{
   const currentUser = window.localStorage.getItem("currentuser");
    const loadedState = window.localStorage.getItem("preferences");
    var preferences = loadedState !== null
      ? JSON.parse(loadedState)
      : initialState;
    var muiTheme = {palette: { mode:preferences?.mode||"light"}};

    return {
      user: currentUser ? JSON.parse(currentUser): null,
      muiTheme: muiTheme,
      preferences: { ...preferences },
      config: null
    }
  });

  const setUser= useCallback(
    user => dispatch({ type: SETUSER, user }),
    []
  );
  
  const setPreferences = useCallback(
    preferences => dispatch({ type: SETPREF, preferences }),
    []
  );

    const setConfig = useCallback(
        config => dispatch({ type: SETCONFIG, config }),
        []
    );

    return [state, { setUser, setPreferences, setConfig }];
};

export {AuthProvider, useAuth, useUserState}